<template>
<div class="chapter">
<div class="inner_page">
<div class="img_container">
<img alt="Image" class="bor" src="images/img1.jpg"/>
<div class="box_1">
<p class="cap"><em class="italic">A Sherman III of HQ, 8th Armoured Brigade, drives clear of a landing craft on 10 June 1944. The brigade's colourful Fox Face formation badge with the combined AoS sign of a white 993 on a red square, incorporating the 2 inch white bar identifying army troops, has been painted onto the transmission coverto the right of the tank's name.</em> Virgin.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Front.vue?0550de2b